import accessGuard from '@/router/middleware/accessGuard'
import beforeEach from '@/router/middleware/beforeEach'
import emptyCampaignGuard from '@/router/middleware/emptyCampaignGuard'
import gtmMiddleware from '@/router/middleware/gtmMiddleware'
import noCommingBackGuard from '@/router/middleware/noCommingBackGuard'
import pageLayout from '@/router/middleware/pageLayout'
import sampleGuard from '@/router/middleware/sampleGuard'
import scrollBehavior from '@/router/scrollBehavior'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Router = {
    router: null,

    create (routes) {
        if (!this.router) {
            this.router = new VueRouter({
                routes: routes,
                scrollBehavior: scrollBehavior,
                mode: 'history'
            })

            this.router.beforeEach(sampleGuard)
            this.router.beforeEach(beforeEach)
            this.router.beforeEach(emptyCampaignGuard)
            this.router.beforeEach(accessGuard)
            this.router.beforeEach(pageLayout)
            this.router.beforeEach(noCommingBackGuard)

            if (process.env.NODE_ENV !== 'development') {
                this.router.beforeEach(gtmMiddleware)
            }
        }

        return this.router
    }
}

export default Router